import script from "./ChatCallMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatCallMessage.vue?vue&type=script&setup=true&lang=ts"

import "./ChatCallMessage.vue?vue&type=style&index=0&id=0d3879a0&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d3879a0"]])

export default __exports__